// extracted by mini-css-extract-plugin
module.exports = {"hero":"bk_fw"};